import React from 'react';
import FieldLabelsList from './FieldLabelsList';

function AvailableTables() {
  return (
    <FieldLabelsList
      fieldType="table"
      paneTitleId="ui-reports.settings.sections.dataModels.pages.availableTables.lable"
      nameColumnId="ui-reports.sections.dataModels.availableTables.columns.name"
      paneId="available-tables-settings-pane"
      listId="available-tables-list"
    />
  );
}

export default AvailableTables;
